import React from 'react';
import { TextField, InputAdornment, Box } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export default function MonthPicker({ value, onChange }) {
  // value: JS Date
  // onChange: (date: Date) => void
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <TextField
        type="month"
        size="small"
        variant="outlined"
        value={value.toISOString().slice(0, 7)}
        onChange={e => {
          const [year, month] = e.target.value.split('-');
          const newDate = new Date(Number(year), Number(month) - 1, 1);
          onChange(newDate);
        }}
        sx={{
          minWidth: 140,
          bgcolor: '#fff',
          borderRadius: 2,
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            fontWeight: 500,
            fontSize: '0.95rem',
            background: '#fff',
          },
          '& input': {
            padding: '8.5px 14px',
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <CalendarMonthIcon sx={{ color: '#3b82f6', fontSize: 20 }} />
            </InputAdornment>
          ),
        }}
        inputProps={{
          max: new Date().toISOString().slice(0, 7),
          style: { cursor: 'pointer' },
        }}
      />
    </Box>
  );
}
